import { ArticleType, ArticleTypeExternal } from '@nemuru-eng/js-api-client';

import { ICON_NAMES } from '@/config/config';

export const getIconByArticleType = (articleType: ArticleTypeExternal | ArticleType) => {
  switch (articleType) {
    case ArticleTypeExternal.FLIGHT:
      return ICON_NAMES.FLIGHT_SMALL;
    case ArticleTypeExternal.PRODUCT:
      return ICON_NAMES.PRODUCT;
    case ArticleTypeExternal.ACCOMMODATION:
      return ICON_NAMES.ACCOMMODATION;
    case ArticleTypeExternal.SERVICE:
      return ICON_NAMES.SERVICE;
    case ArticleTypeExternal.AUTOMOBILE:
      return ICON_NAMES.AUTO;
    case ArticleTypeExternal.TRAVEL:
      return ICON_NAMES.TRAVEL;
    default:
      return ICON_NAMES.PRODUCT;
  }
};
